import axios from 'axios';

const instance = axios.create({ baseURL: process.env.REACT_APP_URL_BASE });

const request = {
    post: (url: string, body: any, token: string) => instance.post(url, body, { headers: { 'Authorization': 'Bearer ' + token, "content-type": "multipart/form-data" } } ),
}

export default request;